"use client"

import { LockIcon } from "@/components/icons/pixel-icons"
import { ENEMY_SPRITESHEET, ENEMY_SPRITE_COUNT, ENEMY_SPRITE_INDEX } from "@/components/game-ui/enemy-sprite-index"
import { spriteStripStyle } from "@/components/game-ui/sprite-strip"
import { CodexArtPlaceholder } from "../codex-art-placeholder"



interface EnemyThumbnailProps {
  enemyId: string
  enemyName: string
  isSelected: boolean
  isLocked: boolean
  onClick: () => void
}

export const EnemyThumbnail = ({
  enemyId,
  enemyName,
  isSelected,
  isLocked,
  onClick,
}: EnemyThumbnailProps) => {
  const spriteIndex = ENEMY_SPRITE_INDEX[enemyId]
  const hasSprite = spriteIndex !== undefined

  return (
    <button
      onClick={onClick}
      className={`relative aspect-square rounded-lg overflow-hidden transition-all ${
        isSelected
          ? "ring-2 ring-amber-400 ring-offset-2 ring-offset-slate-900 scale-105"
          : "ring-1 ring-amber-600/30 hover:ring-amber-500/50 hover:scale-102"
      } ${isLocked ? "cursor-default" : "cursor-pointer"}`}
      style={{
        backgroundColor: "#2d3748",
      }}
      title={isLocked ? "Not yet discovered" : enemyName}
      disabled={isLocked}
    >
      {/* Enemies you have not met yet stay hidden behind a bare "?" */}
      {isLocked ? (
        <CodexArtPlaceholder dimmed />
      ) : hasSprite ? (
        <div
          className="w-full h-full"
          style={{
            backgroundImage: `url(${ENEMY_SPRITESHEET})`,
            ...spriteStripStyle(spriteIndex, ENEMY_SPRITE_COUNT),
          }}
        />
      ) : (
        // Discovered, but no portrait in the strip yet
        <CodexArtPlaceholder name={enemyName} />
      )}

      {/* Locked overlay */}
      {isLocked && (
        <div className="absolute inset-0 flex items-center justify-center bg-black/60">
          <LockIcon size={32} className="text-gray-400" />
        </div>
      )}
    </button>
  )
}
